module.exports = __webpack_public_path__ + "static/fp-about-cyd-logo-2dd48c2cbdec8300d9b146f651a1d38b.png";